export default __webpack_public_path__ + "static/media/Manage money-amico 1.8806999b.svg";